import { LearningSortEnum } from './__generated__/GoalHighlightsTabQuery.graphql';

export const LEARNINGS_SORT: LearningSortEnum[] = ['CREATION_DATE_ASC'];
export const TAGS_COUNT = 200;
